// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"178":"a0c53f9011b13770","213":"d20df827dce7de38","489":"83aa5781a0dadc1f","650":"c1b0fc35b82b1fe0"}[chunkId] + ".js";
};